module.exports = __webpack_public_path__ + "media/components/country-flag/static/mn-eb60a786e6d19342ab3695b94da6d747.svg";